import BaseShare from './BaseShare'
import PortfolioShareInterface from './PortfolioShareInterface'
import PortfolioShareOrder from './PortfolioShareOrder'

type ShareCompany = {
	id: string,
	name: string,
};

type Price = {
	price: number,
	currency: string,
	date: string,
	currencyConverted: boolean,
};

export default class PortfolioShare extends BaseShare implements PortfolioShareInterface {
	id: string;

	amount: number;

	investmentHorizon?: number;

	priceTarget?: number|null;

	priceTargetCurrency?: number|null;

	notes?: string|null;

	orders: PortfolioShareOrder[];

	constructor(
		id: string,
		company: ShareCompany,
		securityName: string,
		latestPrice: Price | null,
		amount: number,
		investmentHorizon?: number,
		priceTarget?: number|null,
		priceTargetCurrency?: number|null,
		notes?: string|null,
		orders?: PortfolioShareOrder[],
	) {
		super(company, securityName, latestPrice)
		this.id = id
		this.amount = amount
		this.investmentHorizon = investmentHorizon
		this.priceTarget = priceTarget
		this.priceTargetCurrency = priceTargetCurrency
		this.notes = notes
		this.orders = orders || []
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	static deserialize(data: any): PortfolioShare {
		return new this(
			data.id,
			{
				id: data.company.id,
				name: data.company.name,
			},
			data.security_name,
			data.latest_share_price ? {
				price: data.latest_share_price.price,
				currency: data.latest_share_price.currency,
				date: data.latest_share_price.date,
				currencyConverted: data.latest_share_price.currency_converted,
			} : null,
			data.amount,
			data.investment_horizon,
			data.price_target,
			data.price_target_currency,
			data.notes,
			data.orders?.map((order: any) => PortfolioShareOrder.deserialize(order)),
		)
	}

	static sortDesc(shares: PortfolioShareInterface[]): PortfolioShareInterface[] {
		return shares.sort((a: PortfolioShareInterface, b: PortfolioShareInterface) => {
			if ((a.getValue() || 0) > (b.getValue() || 0)) {
				return -1
			}

			if ((a.getValue() || 0) < (b.getValue() || 0)) {
				return 1
			}

			return 0
		})
	}

	serialize(): any {
		return {
			id: this.id,
			company: this.company,
			security_name: this.securityName,
			latest_share_price: this.latestPrice ? {
				price: this.latestPrice.price,
				currency: this.latestPrice.currency,
				date: this.latestPrice.date,
				currency_converted: this.latestPrice.currencyConverted,
			} : null,
			amount: this.amount,
			investment_horizon: this.investmentHorizon || null,
			price_target: this.priceTarget || null,
			price_target_currency: this.priceTargetCurrency || null,
			notes: this.notes || null,
		}
	}

	getValue(): number|null {
		if (!this.latestPrice) {
			return null
		}

		return this.latestPrice.price * this.amount
	}
}
